module.exports = __webpack_public_path__ + "img/icon_post_outlined.4bc2f1f6.svg";